module.exports = __webpack_public_path__ + "static/media/SchoolImag.49aad2df.png";